import * as React from "react"
import {Fragment} from "react"
import {Grid} from "@mui/material";
import {ButtonIconSeeker, ButtonSeeker, IconSeeker} from "@ui-seeker/core";

import {useRepricingFormData} from "../../@hooks";
import RepricingFormScopeTypeSelect from "./Type";
import RepricingFormScopeCriterionSelect from "./Criterion";
import RepricingFormScopeValueSelects from "./Value";
import RepricingFormScopeRemoveButton from "./Remove";
import RepricingCrudFormTitleRow from "../TitleRow";


export default function RepricingCrudFormScopeRow() {
    const { dataScope, criterionDisplayed, handleAddScope } = useRepricingFormData()

    return <>
        <Grid item xs={12}>
            <RepricingCrudFormTitleRow
                icon="sliders"
                title="Scope"
                subtitle="Select the product assortment to be included in your rule."
            />
        </Grid>

        { dataScope.map(({ operation, key, value }, idx) => <Fragment key={idx}>
            <Grid item xs={2}>
                <RepricingFormScopeTypeSelect value={operation} criterion={key} />
            </Grid>
            <Grid item xs={2}>
                <RepricingFormScopeCriterionSelect criterion={key} />
            </Grid>
            <Grid item xs={idx === 0 ? 8 : 7}>
                <RepricingFormScopeValueSelects criterion={key} value={value} />
            </Grid>
            { idx !== 0 && <Grid item xs={1}>
                <RepricingFormScopeRemoveButton criterion={key} />
            </Grid> }
        </Fragment>) }

        <Grid item xs={1}>
            <ButtonSeeker
                disabled={criterionDisplayed.length >= 4}
                sx={{ width: 1 }}
                startIcon={<IconSeeker icon="add" />}
                onClick={handleAddScope}
            >
                AND
            </ButtonSeeker>
        </Grid>

        <Grid item xs={11} />
    </>
}